import React, { Component } from "react";

class Instagram extends Component {
  render() {
    return (
      <a
        className="footer-icon"
        href="https://www.instagram.com/danebrwn47/?hl=en"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg
          width="50"
          height="52"
          viewBox="0 0 50 52"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M32.4511 13.6353H17.5489C15.1702 13.6353 13.235 15.6191 13.235 18.0574V33.3341C13.235 35.7724 15.1702 37.7568 17.5489 37.7568H32.4511C34.8297 37.7568 36.7655 35.773 36.7655 33.3341V18.0574C36.7655 15.6191 34.8303 13.6353 32.4511 13.6353ZM25 33.6367C20.7291 33.6367 17.2542 30.0745 17.2542 25.6958C17.2542 21.3175 20.7291 17.7554 25 17.7554C29.2715 17.7554 32.7464 21.3175 32.7464 25.6958C32.7464 30.074 29.2709 33.6367 25 33.6367ZM32.9954 19.3971C31.9843 19.3971 31.1621 18.5542 31.1621 17.5184C31.1621 16.4825 31.9843 15.6396 32.9954 15.6396C34.0059 15.6396 34.8281 16.4825 34.8281 17.5184C34.8281 18.5542 34.0059 19.3971 32.9954 19.3971Z"
            fill="#E1306C"
          />
          <path
            d="M25 21.1104C22.5345 21.1104 20.5269 23.1673 20.5269 25.6947C20.5269 28.2233 22.5345 30.2808 25 30.2808C27.4666 30.2808 29.4726 28.2233 29.4726 25.6947C29.4726 23.1678 27.4661 21.1104 25 21.1104Z"
            fill="#E1306C"
          />
          <path
            d="M25 0C11.1934 0 0 11.4736 0 25.6257C0 39.7779 11.1934 51.2515 25 51.2515C38.8066 51.2515 50 39.7779 50 25.6257C50 11.4736 38.8066 0 25 0ZM40.0382 33.3325C40.0382 37.6212 36.6352 41.1094 32.4511 41.1094H17.5489C13.3654 41.1094 9.96179 37.6212 9.96179 33.3325V18.0572C9.96179 13.769 13.3654 10.2802 17.5489 10.2802H32.4511C36.6352 10.2802 40.0382 13.769 40.0382 18.0572V33.3325Z"
            fill="#E1306C"
          />
        </svg>
      </a>
    );
  }
}

export default Instagram;
